/**
 * 플랫폼 감지 유틸리티
 */

/**
 * 현재 플랫폼 감지
 * @returns {'ios' | 'android' | 'desktop'}
 */
export const detectPlatform = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // iOS 감지
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'ios';
  }

  // Android 감지
  if (/android/i.test(userAgent)) {
    return 'android';
  }

  return 'desktop';
};

/**
 * 모바일 기기인지 확인
 * @returns {boolean}
 */
export const isMobile = () => {
  const platform = detectPlatform();
  return platform === 'ios' || platform === 'android';
};

/**
 * 앱 스토어 URL 가져오기
 * @returns {string | null}
 */
export const getAppStoreUrl = () => {
  const platform = detectPlatform();

  if (platform === 'android') {
    // TODO: 실제 앱 패키지명으로 변경 필요
    return 'https://play.google.com/store/apps/details?id=com.edustaff.app';
  }

  if (platform === 'ios') {
    // TODO: 실제 앱 ID로 변경 필요
    return 'https://apps.apple.com/app/edustaff/id123456789';
  }

  return null;
};

/**
 * Deep Link 시도 (앱이 설치되어 있으면 앱으로 이동)
 * @param {string} deepLinkUrl - 앱 딥링크 URL (예: edustaff://lessons/123)
 * @param {string} fallbackUrl - 앱이 없을 때 이동할 URL (앱 스토어)
 */
export const tryDeepLink = (deepLinkUrl, fallbackUrl) => {
  const platform = detectPlatform();

  if (platform === 'desktop') {
    // 데스크톱에서는 딥링크 시도하지 않음
    return;
  }

  // 앱 열기 시도
  const start = Date.now();
  window.location.href = deepLinkUrl;

  // 2초 후에도 페이지에 있으면 앱이 없는 것으로 간주
  setTimeout(() => {
    const end = Date.now();
    if (end - start < 2500 && fallbackUrl) {
      window.location.href = fallbackUrl;
    }
  }, 2000);
};

const platformUtils = {
  detectPlatform,
  isMobile,
  getAppStoreUrl,
  tryDeepLink
};

export default platformUtils;
